module.exports = __webpack_public_path__ + "static/media/Sneaky Line.bc8018cf.jpg";